import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#3778C2'
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        borderBottomColor: '#3778C2',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 24,
        fontSize: 12,
        fontStyle: 'bold',
    },
    description: {
        width: '85%',
        textAlign: 'right',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        paddingRight: 8,
    },
    total: {
        width: '15%',
        textAlign: 'right',
        paddingRight: 8,
    },
});

const Cgst = ({ items}) => {
    // console.log(`Cgst() :: items.paymentDetails: `, items.paymentDetails);
    
    const sgst = items?.paymentDetails?.gst?.sgst ?? undefined;
    const cgst = items?.paymentDetails?.gst?.cgst ?? undefined;
    const igst = items?.paymentDetails?.gst?.igst ?? undefined;
    // console.log(`Cgst() :: sgst: `, sgst, ` cgst: `, cgst, ` igst: `, igst);
   
    // const cgst = items.gst.cgst
    // const igst = items.igst
    // console.log("discount",total)
    return (
        <View style={styles.row} >
            <Text style={styles.description}>CGST</Text>
            <Text style={styles.total}>{cgst}</Text>
        </View>
        
        
    )
};

export default Cgst;